module.exports = __webpack_public_path__ + "static/media/S10_W.7a7f188c.png";